import React from 'react'
import { useAppSelector } from '../../../../slices/store'
import { StyledResults } from './styles';

export const Results = () => {
  const {resultTable} = useAppSelector((s) => s.mainStore);

  return resultTable && (
    <StyledResults>Results:
      <table>
        <tr>
          <th>Nickname</th>
          <th>Score</th>
        </tr>
      {resultTable.map(([user, score]) => <tr><td className='nickname-cell'>{user}</td><td className='score-cell'>{score}</td></tr>)}
      </table>
    </StyledResults>
  )
}
